(ns minorodata.components.dag.utils
  (:require [minorodata.app.handlers :refer [dispatch]]))

(defn go-to-dag
  [transform]
  (let [{:transform/keys [master-id]} transform]
    (dispatch [:app.events/navigate :dag nil {:focus master-id}])))
